import { Link } from "gatsby"
import React, { useState, useEffect } from "react"

const btmNavItems = [
  { label: "フードデリバリーのメリット", path: "/merit" },
  {
    label: "出前館の強み",
    path: "/advantage",
    children: [{ label: "選べるプラン", path: "/advantage/plan/" }],
  },
  { label: "出店費用", path: "/cost" },
  { label: "出店の流れ", path: "/start-guide" },
  { label: "事例紹介", path: "/cases" },
  { label: "よくある質問", path: "/faq" },
]

const BtmNav = ({ location }) => {
  const [currentSecondLevelLabel, setCurrentSecondLevelLabel] = useState(null)
  const [itemsToDisplay, setItemsToDisplay] = useState(btmNavItems)

  useEffect(() => {
    const modifiedPath = location.pathname.replace("/restaurant", "")

    const matchedSecondLevelItem = btmNavItems.find(item => {
      return item.children?.some(child => child.path === modifiedPath)
    })

    if (matchedSecondLevelItem) {
      setCurrentSecondLevelLabel(matchedSecondLevelItem.label)
      setItemsToDisplay([
        {
          label: matchedSecondLevelItem.label,
          path: matchedSecondLevelItem.path,
        },
        ...matchedSecondLevelItem.children,
      ])
    } else {
      setCurrentSecondLevelLabel(null)
      setItemsToDisplay(btmNavItems)
    }
  }, [location.pathname])

  return (
    <div className="btm-nav">
      <div className="container">
        {currentSecondLevelLabel && (
          <p className="btm-nav__title">{currentSecondLevelLabel}</p>
        )}
        <ul className="btm-nav__list">
          {itemsToDisplay.map((item, index) => (
            <li className="btm-nav__item" key={`btm-nav_${index}`}>
              <Link
                to={item.path}
                className="btm-nav__link"
                activeClassName="active"
              >
                {item.label}
                <span className="btm-nav__arrow">
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.2117 10.2945L10.5507 7.63358C10.3341 7.41691 10.3341 7.06691 10.5507 6.85024C10.7674 6.63358 11.1174 6.63358 11.3341 6.85024L14.893 10.4092C15.0256 10.5109 15.1115 10.6709 15.1115 10.8501C15.1115 11.0125 15.0409 11.1592 14.9288 11.261L11.3341 14.8558C11.2237 14.9662 11.0859 15.0163 10.9425 15.0169C10.799 15.0162 10.6612 14.9607 10.5507 14.8558C10.3341 14.6391 10.3341 14.2891 10.5507 14.0725L13.2176 11.4056H6.77821C6.47266 11.4056 6.22266 11.1556 6.22266 10.8501C6.22266 10.5445 6.47266 10.2945 6.77821 10.2945H13.2117Z"
                      fill="white"
                    />
                    <path
                      d="M10.9425 15.0169L10.9452 15.0169H10.9396L10.9425 15.0169Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      {/* container */}
    </div>
  )
}

export default BtmNav
